var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import fetch from 'isomorphic-fetch';
import _ from 'lodash';
import { searchTypes } from './searchType';
import { removeTagsFromString } from './string';
export * from './searchType';
export * from './string';
var useTypeIds = [
    // 優先度高
    'journal-article',
    'proceedings-article',
    // 優先度中
    'book-section',
    'monograph',
    'report',
    'book',
    'book-chapter',
    'edited-book',
    // 優先度低
    'book-track',
    'book-part',
    'other',
    'standard',
    'dissertation'
];
var useSearchTypes = searchTypes.filter(function (t) { return useTypeIds.includes(t.id); });
var filterTypes = useSearchTypes.map(function (t) { return "type:" + t.id; }).join(',');
export var paperInitState = {
    authors: '',
    title: '',
    journal: '',
    year: undefined,
    doi: '',
    citedCount: undefined,
    type: '',
    url: '',
    abstract: '',
    rdocConstructs: [],
    unitOfAnalysis: [],
    dsm5: [],
    compMathMethodExperimentalDesign: [],
    compMathMethodDataType: [],
    compMathMethodModels: [],
    symptomatology: [],
    hypothesis: '',
    prediction: '',
    relevantPapers: '',
    comment: '',
    debug: '' // NOTE: デバッグ用
};
var getAuthors = function (paper) {
    if (paper.author) {
        return paper.author.map(function (a) { return _.pick(a, ['family', 'given']); });
    }
    if (paper.editor) {
        return paper.editor.map(function (a) { return _.pick(a, ['family', 'given']); });
    }
    return [];
};
var getYear = function (paper) {
    if (paper['published-print']) {
        return paper['published-print']['date-parts'][0][0];
    }
    if (paper['published-online']) {
        return paper['published-online']['date-parts'][0][0];
    }
    if (paper.posted) {
        return paper.posted['date-parts'][0][0];
    }
    return undefined;
};
var getJournal = function (paper) {
    if (paper['container-title']) {
        return paper['container-title'][0];
    }
    if (paper['group-title']) {
        return paper['group-title'];
    }
    if (paper.publisher) {
        return paper.publisher;
    }
    return undefined;
};
var getPaperDetails = function (item) {
    // 著者取得: authors
    var authorsArray = getAuthors(item);
    var authors = authorsArray
        .map(function (a) { return "" + (a.given ? a.given + " " : '') + (a.family || ''); })
        .join(', ');
    // タイトル取得: title
    // subtitleがあるときは付与する
    // eslint-disable-next-line no-nested-ternary
    var title = item.title
        ? item.subtitle && !_.isEmpty(item.subtitle[0])
            ? item.title[0] + ": " + item.subtitle[0]
            : item.title[0]
        : '';
    // 出版取得: journal
    var journal = getJournal(item) || '';
    if (_.isEmpty(journal)) {
        console.error('This Paper do not have container title.');
    }
    // 出版年取得: year
    var year = getYear(item) || undefined;
    if (_.isUndefined(year)) {
        console.error('This Paper do not have year.', year);
    }
    // doi取得: doi
    var doi = item.DOI;
    // 被引用数: citedCount
    var citedCount = item['is-referenced-by-count'];
    // 論文URL: url
    var url = item.URL;
    // アブスト取得： abstract
    var abstract = item.abstract ? removeTagsFromString(item.abstract) : '';
    var type = item.type || '';
    var crid = item.DOI;
    // NOTE: デバッグ用
    var debug = JSON.stringify(item);
    return __assign(__assign({}, paperInitState), { authors: authors, title: title, journal: journal, year: year, doi: doi, citedCount: citedCount, type: type, url: url, abstract: abstract, 
        //
        crid: crid, debug: debug // NOTE: デバッグ用
     });
};
export var getCrossRefPapers = function (_a) {
    var term = _a.term;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, jsonData, crossRefItems, papers, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (_.isEmpty(term)) {
                        throw new Error('Terms is empty.');
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(
                        // '/stubs/crossrefdata.json'
                        // &filter=${filterTypes}
                        // &sort=score&order=desc
                        // &sample=100
                        "https://api.crossref.org/works?query.bibliographic=" + term + "&filter=" + filterTypes + "&sort=score&order=desc&mailto=" + (process.env.REACT_APP_CROSSREF_MAILTO || ''))];
                case 2:
                    data = _b.sent();
                    return [4 /*yield*/, data.json()];
                case 3:
                    jsonData = (_b.sent());
                    crossRefItems = jsonData.message.items;
                    papers = crossRefItems.map(function (item) {
                        return getPaperDetails(item);
                    });
                    // ベストなソートをする
                    // const sortedPapers = matchSorter(papers, term, {
                    //   keys: ['title', 'authors', 'year', 'journal', 'abstract'],
                    //   threshold: matchSorter.rankings.NO_MATCH
                    // })
                    // return sortedPapers
                    return [2 /*return*/, papers];
                case 4:
                    e_1 = _b.sent();
                    console.error(e_1);
                    throw new Error();
                case 5: return [2 /*return*/];
            }
        });
    });
};
// NOTE: Mock作成用のランダムPickupです
export var getCrossRefRandomPapers = function (sample) { return __awaiter(void 0, void 0, void 0, function () {
    var data, jsonData, crossRefItems, papers, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (sample < 1 || sample > 100) {
                    throw new Error('sampleは1〜100の間で指定して下さい');
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(
                    // '/stubs/crossrefdata.json'
                    // &filter=${filterTypes}
                    // &sort=score&order=desc
                    "https://api.crossref.org/works?sample=" + sample + "&mailto=" + (process.env.REACT_APP_CROSSREF_MAILTO || ''))];
            case 2:
                data = _a.sent();
                return [4 /*yield*/, data.json()];
            case 3:
                jsonData = (_a.sent());
                crossRefItems = jsonData.message.items;
                papers = crossRefItems.map(function (item) {
                    return getPaperDetails(item);
                });
                return [2 /*return*/, papers];
            case 4:
                e_2 = _a.sent();
                console.error(e_2);
                throw new Error();
            case 5: return [2 /*return*/];
        }
    });
}); };
export var getCrossRefPaperByDoi = function (_a) {
    var doi = _a.doi;
    return __awaiter(void 0, void 0, void 0, function () {
        var crossRefItem, paper, e_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getCrossrefItemData({ doi: doi })];
                case 1:
                    crossRefItem = _b.sent();
                    if (!crossRefItem) {
                        return [2 /*return*/, []];
                    }
                    paper = getPaperDetails(crossRefItem);
                    return [2 /*return*/, [paper]];
                case 2:
                    e_3 = _b.sent();
                    console.error(e_3);
                    throw new Error();
                case 3: return [2 /*return*/];
            }
        });
    });
};
export var getCrossrefItemData = function (_a) {
    var doi = _a.doi;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, jsonData, e_4;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (_.isEmpty(doi)) {
                        throw new Error('Doi is empty.');
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch("https://api.crossref.org/works/" + doi + "?mailto=" + (process.env.REACT_APP_CROSSREF_MAILTO || ''))];
                case 2:
                    data = _b.sent();
                    if (data.status === 404) {
                        return [2 /*return*/, undefined];
                    }
                    return [4 /*yield*/, data.json()];
                case 3:
                    jsonData = (_b.sent());
                    return [2 /*return*/, jsonData.message];
                case 4:
                    e_4 = _b.sent();
                    console.error(e_4);
                    throw new Error('getCrossRefData error');
                case 5: return [2 /*return*/];
            }
        });
    });
};
